// extracted by mini-css-extract-plugin
export default {"container":"sK-z","darkBackground":"tK-z","whiteBackground":"uK-z","headerButton":"vK-z","calloutHeading":"wK-z","calloutSubHeading":"xK-z"};